import { AppPlanCode, getFullPriceForPlan } from "common/app-plans";
import { OwnerKind } from "common/Database/owner-kind";
import { CardPreview } from "common/firebase-function-types";
import { previewCharge } from "designer/apps/orgs/orgs-lib";

export type GetEstimateArgs = {
    ownerID: string;
    ownerKind: OwnerKind;
    appID: string;
    appPlanCode: AppPlanCode;
    numUsers: number;
};

export type GetEstimateResult = {
    newEstimate: number;
    newCardPreview: CardPreview;
};

export enum CardState {
    Loading = "loading",
    NoCard = "no-card",
    CardPresent = "card-present",
}

export function getCardState(cardPreview: CardPreview | undefined): CardState {
    if (cardPreview === undefined) return CardState.Loading;
    if (cardPreview !== undefined && cardPreview.last4 === "") return CardState.NoCard;
    if (cardPreview !== undefined && cardPreview.last4.length === 4) return CardState.CardPresent;

    // This should never happen
    return CardState.Loading;
}

export async function getEstimateAndCardPreview(args: GetEstimateArgs): Promise<GetEstimateResult> {
    const { ownerID, ownerKind, appID, appPlanCode, numUsers } = args;

    const organizationID = ownerKind === OwnerKind.Organization ? ownerID : undefined;
    const charge = await previewCharge({
        organizationID,
        withChange: {
            appID,
            plan: appPlanCode,
            numUsers: numUsers,
        },
    });

    const cardPreview = charge?.immediate?.cardPreview ??
        charge?.monthly?.cardPreview ?? {
            last4: "",
            address: {
                line1: "",
                line2: "",
                country: "",
                state: "",
                city: "",
                zip: "",
            },
            email: "",
            name: "",
        };

    // Undefined if the user has no payment info
    if (charge?.immediate === undefined) {
        const newEstimate = getFullPriceForPlan(appPlanCode, numUsers);
        return { newEstimate, newCardPreview: cardPreview };
    }
    return { newEstimate: charge.immediate.amountDue / 100, newCardPreview: cardPreview };
}
